import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  border-right: 1px solid ${({ theme }) => theme.colors.black4};
  padding: 16px 12px 16px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  overflow-y: auto;
  position: relative;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  padding: 4px 0px 4px 12px;
  align-items: center;
  gap: 12px;
  width: 100%;
  font-weight: 600;
`;

export const ActionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  position: sticky;
  bottom: 0;

  @media (min-width: ${({ theme }) => theme.mediaQueries.xl}) {
    flex-direction: row;
  }
`;

export const PendingValidationWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.orange3};
  background: ${({ theme }) => theme.colors.orange1};
`;

export const MessageTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-weight: 600;
`;

export const MessageCountDescriptionWrapper = styled.div`
  display: flex;
  padding-left: 32px;
`;

export const InvalidQuestionsWrapper = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.red3};
  background: ${({ theme }) => theme.colors.red1};
`;
